<script setup>
// ========================================
// VTextarea with "characters left until the end of the SMS part" in its bottom-right corner.
// Other attributes (placeholder, rows, auto-grow...) go straight to VTextarea.
// ========================================
import { getSmsInfo, SMS_MAX_PARTS } from '@/utils/sms'

const props = defineProps({
  // Count the text as sent with "replace special characters"
  normalize: {
    type: Boolean,
    default: false,
  },
})

const text = defineModel({ type: String, default: '' })

const sms = computed(() => getSmsInfo(text.value, props.normalize))
const isOverLimit = computed(() => sms.value.parts > SMS_MAX_PARTS)
</script>

<template>
  <VTextarea
    v-model="text"
    class="sms-textarea"
  >
    <template #append-inner>
      <span
        class="sms-textarea__counter px-2 py-1 rounded-ts-lg rounded-be-lg"
        :class="isOverLimit ? 'text-error' : 'text-high-emphasis'"
      >
        {{ isOverLimit ? $t('smsLimitReached') : $t('smsCharsLeft', sms.capacity - sms.length) }}
      </span>
    </template>
  </VTextarea>
</template>

<style scoped lang="scss">
// Strip for the counter below the textarea itself (not its padding), so scrolled text never runs under the counter
.sms-textarea :deep(.v-field) {
  --v-field-padding-bottom: 20px;
  padding-right: 0!important;
}

.sms-textarea :deep(.v-field__field) {
  padding-block-end: 20px; // counter height: text-caption line (18px) + py-1
}

// In the field's corner (rounded like the field), under the outline, so the field's border runs over its edges
.sms-textarea__counter {
  position: absolute;
  background: rgba(var(--v-theme-on-surface), 0.08);
  inset-block-end: 0;
  inset-inline-end: 0;
  pointer-events: none;
  font-size: 0.6rem;
}
</style>
